goog.provide("shadow.js.shim.module$$mui$x_date_pickers$TimePicker");
goog.provide("module$shadow_js_shim_module$$mui$x_date_pickers$TimePicker");
shadow.js.shim.module$$mui$x_date_pickers$TimePicker = shadow.js.nativeProvides["@mui/x-date-pickers/TimePicker"] = shadow$bridge("@mui/x-date-pickers/TimePicker");
module$shadow_js_shim_module$$mui$x_date_pickers$TimePicker.default = shadow.js.shim.module$$mui$x_date_pickers$TimePicker;
